import * as React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import Loader from "../Loader";
import { REDIRECT_AFTER_LOGIN } from "../auth/OTPSignIn";

// For pages a signed-in user has no reason to see, like sign-in. A bookmarked
// sign-in URL otherwise asks for a new code while the session is still valid.
// The legacy JWT path keeps its behaviour unchanged.
function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, method } = useAuth();

  if (method !== "cookie") {
    return <React.Fragment>{children}</React.Fragment>;
  }

  // Holding the form until the session probe settles avoids flashing it at a
  // user who is about to be redirected.
  if (!isInitialized) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return <Navigate to={REDIRECT_AFTER_LOGIN} replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default GuestGuard;
